import React from 'react';
import { ComponentListType, Typography, VariantsType } from '@wds/typography';
import { PACKAGE_PRICE_TYPE, PACKAGE_PRICE_TYPE_VALUES } from '~shared/types/pricing/package';

import usePackagePriceStyles from '~app/pages/Pricing/components/PackagePrice/useStyles';
import { PackagePriceProps } from './types';

const packagePriceVariantMap: Record<PACKAGE_PRICE_TYPE_VALUES, VariantsType> = {
  [PACKAGE_PRICE_TYPE.SUMMARY]: 'pageTitle',
  [PACKAGE_PRICE_TYPE.DETAIL]: 'sectionTitle',
  [PACKAGE_PRICE_TYPE.COMPARISON]: 'body',
};

const packagePriceComponentMap: Record<PACKAGE_PRICE_TYPE_VALUES, ComponentListType> = {
  [PACKAGE_PRICE_TYPE.SUMMARY]: 'h3',
  [PACKAGE_PRICE_TYPE.DETAIL]: 'h3',
  [PACKAGE_PRICE_TYPE.COMPARISON]: 'span',
};

export default function PackagePrice({
  formattedPrice,
  packagePriceType,
  costUnit,
}: PackagePriceProps): React.ReactElement {
  const { PriceLabel, Price } = usePackagePriceStyles();

  return (
    <div className={PriceLabel} data-testid={`${packagePriceType}PackagePrice`}>
      <Typography
        component={packagePriceComponentMap[packagePriceType]}
        variant={packagePriceVariantMap[packagePriceType]}
        data-testid={`${packagePriceType}PackagePrice__Value`}
        align="center"
      >
        <span className={Price}>{formattedPrice}</span>
        {costUnit && (
          <Typography component="span" variant="body" data-testid={`${packagePriceType}PackagePrice__Unit`}>
            {costUnit}
          </Typography>
        )}
      </Typography>
    </div>
  );
}
